import React, { useState } from 'react';
import { CodeBlock } from './CodeBlock';
import { CodeExample } from '../../types/docs.types';

interface CodeTabsProps {
  examples: CodeExample[];
}

export const CodeTabs: React.FC<CodeTabsProps> = ({ examples }) => {
  const [activeTab, setActiveTab] = useState(0);

  const languageNames: Record<string, string> = {
    javascript: 'JavaScript',
    typescript: 'TypeScript',
    curl: 'cURL',
    python: 'Python',
    php: 'PHP',
    java: 'Java',
    csharp: 'C#',
    go: 'Go',
    ruby: 'Ruby',
    json: 'JSON',
  };

  if (examples.length === 0) return null;

  if (examples.length === 1) {
    return (
      <CodeBlock
        code={examples[0].code}
        language={examples[0].language}
        title={examples[0].title || languageNames[examples[0].language] || examples[0].language}
      />
    );
  }

  return (
    <div className="rounded-xl overflow-hidden border border-gray-800 shadow-sm">
      <div className="bg-[#1e1e2e] border-b border-gray-700/60 px-2 pt-2 flex gap-1 overflow-x-auto">
        {examples.map((example, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`px-3 py-1.5 text-xs font-medium whitespace-nowrap rounded-t-md transition-all duration-150 ${
              activeTab === index
                ? 'bg-[#581689] text-white'
                : 'text-gray-400 hover:text-gray-200 hover:bg-white/5'
            }`}
          >
            {example.title || languageNames[example.language] || example.language}
          </button>
        ))}
      </div>
      <div className="bg-[#1e1e2e]">
        <CodeBlock
          code={examples[activeTab].code}
          language={examples[activeTab].language}
        />
      </div>
    </div>
  );
};
